import { getVideoById, Video } from '../../utils/api/videoApi';
import { Color, colors } from '../../utils/styleguide';
import BigParagraphLayout from '../component-library/layout/BigParagraphLayout';
import { PageSectionComponent } from './pageSections';
import RichText from './RichText';
import sectionToCompatibleProps from './util/sectionToCompatibleProps';

type ServerSideProps = {
  portraitVideo?: Video;
  landscapeVideo?: Video;
};
const BigParagraphSection: PageSectionComponent<ServerSideProps> = ({
  section,
  serverSideProps: { portraitVideo, landscapeVideo },
}) => {
  const { settings } = section.fields || {};
  const { id, title, description, backgroundColor, button } = sectionToCompatibleProps({ section });
  return (
    <BigParagraphLayout
      id={id}
      preamble={<RichText document={title} textColor={colors[settings?.textColor as Color]} />}
      paragraph={
        <RichText document={description} textColor={colors[settings?.textColor as Color]} />
      }
      href={button.href}
      buttonLabel={button.label}
      buttonColor={button.colorContext}
      landscapeVideo={landscapeVideo}
      portraitVideo={portraitVideo}
      backgroundColor={backgroundColor}
    />
  );
};

BigParagraphSection.getCustomServerSideProps = async ({ section }) => {
  const { media } = sectionToCompatibleProps({ section });

  const portraitVideo = getVideoById(media.videoIdPortrait);
  const landscapeVideo = getVideoById(media.videoIdLandscape);
  return { portraitVideo: await portraitVideo, landscapeVideo: await landscapeVideo };
};

export default BigParagraphSection;
